import {
    Box,
    Container,
    Stack,
    Typography,
    // useTheme,
    TextField,
    Paper
} from '@material-ui/core';
// import AddIcon from '@material-ui/icons/Add';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useLocation } from 'react-router-dom';
import { casesApi } from 'src/api/casesApi';
// import { Header } from 'src/components/Header';
import CustomizedTable from 'src/components/tables/CustomizedTable';
// import { CustomButton2 } from 'src/components/widgets/buttons/CustomButton2';
import useGenericStyles from 'src/styles/useGenericStyles';
import setTitle from 'src/utils/setTitle';
// import { NameWithAvatar } from 'src/components/tables/renderers/NameWithAvatar';
import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router';
import CasesSubHeader from 'src/components/cases/CasesSubHeader';
import ProjectsSubHeader from 'src/components/organization/projects/ProjectsSubHeader';

// import { BillingType } from 'src/components/tables/renderers/BillingType';
import { Priority } from 'src/components/tables/renderers/Priority';
import { Status } from 'src/components/tables/renderers/Status';
import { RootState } from 'src/store/store';
import capitalize from 'src/utils/capitalize';
import getProjectTypeShort from 'src/components/organization/projects/projectTypes';
import { BillingType } from 'src/components/tables/renderers/BillingType';
import { isEmpty, isUndefined } from 'lodash';
import convertSecondsToTimeString from 'src/utils/convertSecondsToTimeString';
import { contactsApi } from 'src/api/contactsApi';
// import convertSecondsToTimeString from 'src/utils/convertSecondsToTimeString';
import { Autocomplete } from '@material-ui/lab';

// const useStyles = makeStyles(() => ({
//   checkBoxStyle: {
//     width: "31px !important",
//     maxWidth: "31px !important",
//     minWidth: "31px !important",
//   }
// }));
const DEFAULT_VISIBLE_COLUMNS = ["caseKey", "summary", "createdBy", "caseType", "project", "priority", "status"];

const environmentOptions = [
    { name: 'Local (Not ready for testing)', id: 'local' },
    { name: 'Development', id: 'development' },
    { name: 'Acceptance', id: 'acceptance' },
    { name: 'Testing', id: 'testing' },
    { name: 'Production', id: 'production' }
];

function TestingCases() {
    setTitle('ERP | Cases');
    const { projectID } = useParams();
    const location = useLocation();
    const isProjectRoute = location.pathname.includes('/projects/');
    // const theme = useTheme();

    const [caseTypes, setCaseTypes] = useState([]);
    const [internalUsers, setAllInternalUsers] = useState([]);
    const [allData, setAllData] = useState<any>([]);
    const [page, setPage] = useState<any>(0);
    const [pageSize, setPageSize] = useState<any>(25);
    const handlePage = (temp: number) => {
        setPage(temp);
    };
    const [totalCount, setTotalCount] = useState<number>(0);
    const handlePageSize = (temp: number) => {
        setPageSize(temp);
    };
    const [search, setSearch] = useState<any>('');
    const [fetchingData, setFetchingData] = useState(false);
    const [statusOptions, setStatusOptions] = useState([])
    const [filters, setFilters] = useState<any>({});
    const [sort, setSort] = useState({ field: 'createdAt', order: 'desc' });
    const [priorityOptions, setPriorityOptions] = useState([])
    const [issueTypes, setIssueTypes] = useState([]);
    const [allBillingAccounts, setAllBillingAccounts] = useState([]);
    const [allSprintsByOrganization, setAllSprintsByOrganization] = useState([]);
    const [allExternalUsers, setAllExternalUsers] = useState([]);
    const handleSearch = (val) => {
        setSearch(val);
    };
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [hasAttachments, setHasAttachments] = useState(false);
    // const navigate = useNavigate();
    const classes = useGenericStyles();
    const allProjects = useSelector(
        (state: RootState) => state.projects.allProjects
    );

    // Get project name for ProjectsSubHeader
    const currentProject = allProjects.find(project => project.id === projectID);

    // Breadcrumb data for ProjectsSubHeader
    const breadcrumbData = {
        links: [
            {
                name: 'Projects',
                to: '/projects',
            },
            {
                name: currentProject?.name,
                to: `/projects/${projectID}`,
                // color: '#4baee8',
            },
        ],
    };

    // Add a new state to track initial loading
    const [isInitialized, setIsInitialized] = useState(false);

    const getAllTypesAutoComplete = async () => {
        try {
            const response = await casesApi.getCaseTypes();
            if (response.status === 200) {
                setCaseTypes(response.data);
            }
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching types');
            }
        }
    };

    const getAllInternalUsersAutoComplete = async () => {
        try {
            const res = await casesApi?.getAutoCompleteUser(true);
            setAllInternalUsers(res.data);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching users');
            }
        }
    };


    const getProirityAutoComplete = async () => {
        try {
            const res = await casesApi?.getPriorities();
            setPriorityOptions(res.data);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching users');
            }
        }
    };

    const getStatusAutoComplete = async () => {
        try {
            const res = await casesApi?.getStatuses();
            setStatusOptions(res.data);

            // Set initial filters after loading status options
            const readyForAcceptanceStatus = res.data?.find((item: any) => item.name === 'Ready for Acceptance');
            const acceptanceEnvironment = environmentOptions.find(env => env.id === 'acceptance');

            if (readyForAcceptanceStatus && acceptanceEnvironment) {
                setFilters({
                    Status: [{
                        label: readyForAcceptanceStatus.name,
                        value: readyForAcceptanceStatus.id
                    }],
                    Environment: [{
                        label: acceptanceEnvironment.name,
                        value: acceptanceEnvironment.id
                    }]
                });
            } else if (readyForAcceptanceStatus) {
                setFilters({
                    Status: [{
                        label: readyForAcceptanceStatus.name,
                        value: readyForAcceptanceStatus.id
                    }]
                });
            }
            // Mark initialization as complete after setting filters
            setIsInitialized(true);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching users');
            }
            // Even on error, mark as initialized to prevent infinite loading
            setIsInitialized(true);
        }
    };


    const getIssueTypesAutoComplete = async () => {
        try {
            const res = await casesApi?.getIssueTypes();
            setIssueTypes(res.data);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching issue types');
            }
        }
    };

    const getAllBillingAccounts = async () => {
        try {
            const res = await casesApi?.getAllBillingAccounts();
            setAllBillingAccounts(res.data);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching billing accounts');
            }
        }
    };

    const getAllExternalUsers = async () => {
        try {
            const res = await contactsApi.getAll(0, 1000, true, '');
            setAllExternalUsers(res.data?.data);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching External Clients');
            }
        }
    };


    function groupBySprintNameToArray(data) {
        const grouped = data.reduce((acc, item) => {
            const { name, id } = item;
            if (!acc[name]) {
                acc[name] = [];
            }
            acc[name].push(id);
            return acc;
        }, {});

        return Object.entries(grouped).map(([name, ids]) => ({
            name,
            id: (ids as any).join(","),
        }));
    }

    const getAllSprintsByOrganization = async () => {
        try {
            const res = await casesApi?.getSprintsByOrganization();
            const formattedSprints = groupBySprintNameToArray(res?.data);

            setAllSprintsByOrganization(formattedSprints);
        } catch (error) {
            if (error.message) {
                toast.error(error.message);
            } else {
                toast.error('An error occured while fetching sprints');
            }
        }
    };

    // Add this helper function
    const getAllowedStatuses = () => {
        const allowedStatuses = [
            'Ready for Acceptance',
            'Rejected for Production',
            'Ready for Production',
            'Approved for Production'
        ];
        return statusOptions
            .filter(status => allowedStatuses.includes(status.name))
            .map((status) => ({
                label: status?.name,
                value: status?.id,
            }));
    };

    // Add this helper function for environment options
    const getAllowedEnvironments = () => environmentOptions.map((env) => ({
        label: env.name,
        value: env.id,
    }));

    // Modify the handleClearFilters function
    const handleClearFilters = () => {
        setFilters({});
        setSearch('');
        setHasAttachments(false);
        setStartDate(null);
        setEndDate(null);
    };

    const formatDate = (date) => {
        if (!date) return null;
        const isoString = date.toISOString();
        return isoString.split('T')[0];
    };

    const getAllData = async () => {
        setFetchingData(true);
        try {
            const varr = {
                page,
                pageSize,
                search,
                caseType: filters.Type?.map((itm: any) => itm.value).toString() || null,
                caseKey: filters?.['CASE#']?.map((itm: any) => itm.value).toString() || null,
                summary: filters?.Title?.map((itm: any) => itm.value).toString() || null,
                priority: filters?.Priority?.map((itm: any) => itm.value).toString() || null,
                status: filters?.Status?.map((itm: any) => itm.value).toString() || null,
                environment: filters?.Environment?.map((itm: any) => itm.label).toString() || null,
                issueType: filters?.['Issue Type']?.map((itm: any) => itm.value).toString() || null,
                billingAccountType: filters?.Account?.map((itm: any) => itm.value).toString() || null,
                sprint: filters?.Sprint?.map((itm: any) => itm.value).toString() || null,
                approvedBy: filters["Approved By"]?.map((itm: any) => itm.value).toString() || null,
                projectId: projectID || filters.Project?.map((itm: any) => itm.value).toString() || null,
                to: formatDate(endDate),
                from: formatDate(startDate),
                column: sort?.field,
                sort: sort?.order === 'asc' ? '1' : '-1',
            };
            const keys = Object.keys(varr);
            const values = Object.values(varr);

            // Create an array to store the non-empty key-value pairs
            const queryParams = [];
            for (let i = 0; i < values.length; i++) {
                if (values[i] !== '' && values[i] !== null && values[i] !== undefined) {
                    queryParams.push(`${encodeURIComponent(keys[i])}=${values[i]}`);
                }
            }
            const queryString = queryParams.join('&');
            let response = await casesApi.advanceSearch(queryString);
            if (response?.status === 200) {
                response = response?.data;
                setAllData(response?.data);
                setTotalCount(response?.totalRecords);
            }
            if (response.status === 204) {
                setAllData([]);
                setTotalCount(0);
            }

            setFetchingData(false);
        } catch (error) {
            setFetchingData(false);
            if (error?.response?.status !== 401) {
                toast.error(error?.response?.data?.message);
                setAllData([]);
                setTotalCount(0);
            }
        }
    };

    const customColumns = [
        {
            field: 'caseKey',
            headerName: 'CASE#',
            width: '10%',
            maxWidth: '10%',
            sortable: true,
            filterable: true,
        },
        {
            field: 'summary',
            headerName: 'Title',
            maxWidth: '400px',
            render: (columnValue, data) => (
                <Typography
                    title={capitalize(data?.summary)}
                    sx={{
                        fontFamily: 'Inter',
                        fontSize: 12,
                        fontWeight: 600,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                    {capitalize(data?.summary)}
                </Typography>
            ),
            sortable: true,
            filterable: true,
        },
        {
            field: 'createdBy',
            headerName: 'Reporter',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => (
                <Typography
                    sx={{
                        fontFamily: 'Inter',
                        fontSize: 12,
                        fontWeight: 600,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                    {columnValue?.name}
                </Typography>
            ),
            sortable: true,
            filterable: true,
        },
        {
            field: 'caseType',
            headerName: 'Type',
            render: (columnValue) => (
                <Box
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    title={capitalize(columnValue?.name)}>
                    {getProjectTypeShort(columnValue?.name) ?? ''}
                </Box>
            ),
            maxWidth: '10%',
            width: '10%',
            sortable: true,
            filterable: true,
        },
        {
            field: 'timeEstimate',
            headerName: 'Est.',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => (
                <Box
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color:
                            capitalize(
                                columnValue ? convertSecondsToTimeString(columnValue) : ''
                            ) === 'N/A'
                                ? 'red'
                                : 'initial',
                    }}
                    title={
                        capitalize(convertSecondsToTimeString(columnValue)) === 'N/A'
                            ? 'Hours not quoted'
                            : capitalize(convertSecondsToTimeString(columnValue))
                    }>
                    {capitalize(
                        columnValue ? convertSecondsToTimeString(columnValue) : ''
                    )}
                </Box>
            ),
            sortable: true,
        },
        {
            field: 'project',
            headerName: 'Project',
            render: (columnValue) => (
                <span
                    style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                    {capitalize(columnValue?.name ?? '')}
                </span>
            ),
            width: '12%',
            maxWidth: '12%',
            sortable: true,
            filterable: true,
        },
        {
            field: 'priority',
            headerName: 'Priority',
            maxWidth: '10%',
            width: '9%',
            render: (columnValue) => (
                <Priority priority={capitalize(columnValue?.name ?? '')} />
            ),
            sortable: true,
            filterable: true,
        },
        {
            field: 'status',
            headerName: 'Status',
            maxWidth: '10%',
            width: '11%',
            render: (columnValue) => (
                <Status status={capitalize(columnValue?.name ?? '')} />
            ),
            sortable: true,
            filterable: true,
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            maxWidth: '12%',
            width: '12%',
            render: (columnValue) => (
                <Box>{new Date(columnValue).toLocaleString()}</Box>
            ),
            sortable: true,
        },
        {
            field: 'issueType',
            headerName: 'Issue Type',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => <Box>{columnValue?.name}</Box>,
            sortable: true,
            filterable: true,
        },
        {
            field: 'expense',
            headerName: 'Expense',
            maxWidth: '8%',
            width: '8%',
            render: (columnValue) =>
                columnValue ? <BillingType value={columnValue} /> : 'N/A',
            sortable: true,
        },
        {
            field: 'billingAccountType',
            headerName: 'Account',
            maxWidth: '12%',
            width: '12%',
            render: (columnValue) => <Box>{columnValue?.name}</Box>,
            sortable: true,
            filterable: true,
        },
        {
            field: 'isApproved',
            headerName: 'Approved',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue, data) => <Box>{!isEmpty(data?.caseType) &&
                !isUndefined(data?.caseType) &&
                data?.caseType?.name === 'Application Feature Request' ? (
                columnValue ? (
                    'Approved'
                ) : (
                    'Not Approved'
                )
            ) : (
                'Approval Not Required'
            )}</Box>,
            sortable: true,
            filterable: true,
        },
        {
            field: 'approvedBy',
            headerName: 'Approved By',
            maxWidth: '12%',
            width: '12%',
            render: (columnValue) => <Box>{columnValue?.name || 'N/A'}</Box>,
            sortable: true,
            filterable: true,
        },
        {
            field: 'approvedDate',
            headerName: 'Approved Date',
            maxWidth: '12%',
            width: '12%',
            render: (columnValue) => (
                <Box>{columnValue ? new Date(columnValue).toLocaleString() : 'N/A'}</Box>
            ),
            sortable: true,
        },
        {
            field: 'docUrls.figmaLinks',
            headerName: 'Figma Links',
            maxWidth: '20%',
            width: '20%',
            render: (_, data) => (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    fontSize: '12px'
                }}>
                    {data.docUrls?.figmaLinks?.length > 0 ? (
                        data.docUrls.figmaLinks.map((link) => (
                            <Box
                                key={link}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span>•</span>
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: '#2563EB',
                                        textDecoration: 'none'
                                    }}
                                >
                                    {link.label || link.url}
                                </a>
                            </Box>
                        ))
                    ) : (
                        'No links'
                    )}
                </Box>
            ),
        },
        {
            field: 'docUrls.googleDocLinks',
            headerName: 'Google Links',
            maxWidth: '20%',
            width: '20%',
            render: (_, data) => (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    fontSize: '12px'
                }}>
                    {data.docUrls?.googleDocLinks?.length > 0 ? (
                        data.docUrls.googleDocLinks.map((link) => (
                            <Box
                                key={link}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span>•</span>
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: '#2563EB',
                                        textDecoration: 'none'
                                    }}
                                >
                                    {link.label || link.url}
                                </a>
                            </Box>
                        ))
                    ) : (
                        'No links'
                    )}
                </Box>
            ),
        },
        {
            field: 'sprint',
            headerName: 'Sprint',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => <Box>{columnValue?.name}</Box>,
            sortable: true,
            filterable: true,
        },
        {
            field: 'releaseVersion',
            headerName: 'Fix Version',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => (

                <Box>{columnValue?.map(v => v?.name || 'N/A').join(', ')}</Box>
            ),
            sortable: true,
        },
        {
            field: 'environment',
            headerName: 'Environment',
            maxWidth: '10%',
            width: '10%',
            render: (columnValue) => {
                console.log(columnValue)
                return <Box>{columnValue}</Box>
            },
            sortable: true,
        },
    ];

    const getFilterOptions = (column) => {
        switch (column) {
            case 'createdBy':
                return internalUsers.map((userObj) => ({
                    label: userObj.name,
                    value: userObj.id,
                }));
            case 'caseType':
                return caseTypes.map((typeObj) => ({
                    label: typeObj.name,
                    value: typeObj.id,
                }));
            case 'project':
                return allProjects.map((projectObj) => ({
                    label: projectObj.name,
                    value: projectObj.id,
                }));
            case 'caseKey':
                return allData.map((projectObj) => ({
                    label: projectObj.caseKey,
                    value: projectObj.caseKey,
                }));
            case 'summary':
                return allData.map((projectObj) => ({
                    label: projectObj.summary,
                    value: projectObj.summary,
                }));
            case 'priority': {
                return priorityOptions.map((priority) => ({
                    label: priority?.name,
                    value: priority?.id,
                }));
            }
            case 'status': {
                const allowedStatuses = [
                    'Ready for Acceptance',
                    'Rejected for Production',
                    'Ready for Production',
                    'Approved for Production'
                ];
                return statusOptions
                    .filter(status => allowedStatuses.includes(status.name))
                    .map((status) => ({
                        label: status?.name,
                        value: status?.id,
                    }));
            }
            case 'issueType': {
                return issueTypes.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                }));
            }
            case 'billingAccountType': {
                return allBillingAccounts.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                }));
            }
            case 'sprint': {
                return allSprintsByOrganization.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                }));
            }
            case 'approvedBy': {
                return allExternalUsers?.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                }));
            }
            case 'isApproved':
                return [
                    {
                        label: 'Approved',
                        value: "true",
                    },
                    {
                        label: 'Not Approved',
                        value: "false",
                    },
                    {
                        label: 'Approval Not Required',
                        value: "anr",
                    },
                ];
            case 'environment': {
                return environmentOptions.map((env) => ({
                    label: env.name,
                    value: env.id,
                }));
            }
            default:
                return [];
        }
    };

    const handleSort = (field) => {
        setSort((prevSort) => ({
            field,
            order:
                prevSort.field === field && prevSort.order === 'asc' ? 'desc' : 'asc',
        }));
    };

    const handleApplyFilter = (
        currentFilterColumn,
        filterValue,
        filterName,
        checked
    ) => {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            if (checked) {
                if (newFilters[currentFilterColumn]) {
                    newFilters[currentFilterColumn].push({
                        label: filterName,
                        value: filterValue,
                    });
                } else {
                    newFilters[currentFilterColumn] = [
                        {
                            label: filterName,
                            value: filterValue,
                        },
                    ];
                }
            } else if (newFilters[currentFilterColumn]) {
                newFilters[currentFilterColumn] = newFilters[
                    currentFilterColumn
                ].filter((obj) => obj.value !== filterValue);

                if (newFilters[currentFilterColumn].length === 0) {
                    delete newFilters[currentFilterColumn];
                }
            }
            return newFilters;
        });
    };

    const handleRemoveFilter = (column) => {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            delete newFilters[column];
            return newFilters;
        });
    };

    // const handleSwitchChange = (event) => {
    //     setHasAttachments(event.target.checked);
    // };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };


    useEffect(() => {
        getStatusAutoComplete()
        getProirityAutoComplete()
        getAllTypesAutoComplete();
        getAllInternalUsersAutoComplete();
        getIssueTypesAutoComplete();
        getAllBillingAccounts();
        getAllSprintsByOrganization();
        getAllExternalUsers();
    }, []);

    // Modify the useEffect to only call getAllData after initialization
    useEffect(() => {
        if (!isInitialized) return; // Skip if not initialized

        getAllData();
    }, [
        isInitialized, // Add isInitialized as dependency
        page,
        pageSize,
        JSON.stringify(filters),
        search,
        sort,
        hasAttachments,
        startDate,
        endDate,
    ]);

    const [visibleColumns, setVisibleColumns] = useState(() => {
        const savedColumns = localStorage.getItem('casesVisibleColumns');
        return savedColumns ? JSON.parse(savedColumns) : DEFAULT_VISIBLE_COLUMNS;
    });

    return (
        <>
            {/* <Header title="Testing Cases">
                <CustomButton2
                    backgroundColor={theme.palette.primary.main}
                    className={classes.button}
                    onClick={() => navigate('/cases/add')}>
                    <AddIcon
                        sx={{
                            marginRight: '5px',
                        }}
                    />
                    Create case
                </CustomButton2>
            </Header> */}
            <Container maxWidth={false} className={classes.container}>
                {isProjectRoute ? (
                    <ProjectsSubHeader
                        projectName={currentProject?.name}
                        search={search}
                        onSearch={handleSearch}
                        filters={filters}
                        onRemoveFilter={handleRemoveFilter}
                        hasAttachments={hasAttachments}
                        onSwitchChange={(checked) => setHasAttachments(checked)}
                        startDate={startDate}
                        onStartDateChange={handleStartDateChange}
                        endDate={endDate}
                        onEndDateChange={handleEndDateChange}
                        onClearFilters={handleClearFilters}
                        breadcrumbData={breadcrumbData}
                        extraFilters={
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Typography
                                        sx={{
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            color: '#8492A6',
                                        }}>
                                        STATUS
                                    </Typography>
                                    <Autocomplete
                                        disableClearable
                                        multiple
                                        limitTags={1}
                                        size="small"
                                        options={getAllowedStatuses()}
                                        value={filters?.Status || []}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        onChange={(_, newValue) => {
                                            if (newValue.length > 0) {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    Status: newValue.map(item => ({
                                                        label: item.label,
                                                        value: item.value
                                                    }))
                                                }));
                                            } else {
                                                handleRemoveFilter('Status');
                                            }
                                        }}
                                        getOptionLabel={(option) => option.label || ''}
                                        sx={{
                                            width: '100%',
                                            minWidth: 220,
                                            '& .MuiOutlinedInput-root': {
                                                paddingRight: '0px !important',
                                                paddingTop: '4px !important',
                                                paddingBottom: '4px !important',
                                            }
                                        }}
                                        PaperComponent={({ children }) => (
                                            <Paper style={{ maxHeight: '250px' }}>{children}</Paper>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder={isEmpty(filters?.Status) ? "Select Status" : ""}
                                                sx={{ minWidth: 180 }}
                                            />
                                        )}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Typography
                                        sx={{
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            color: '#8492A6',
                                        }}>
                                        ENVIRONMENT
                                    </Typography>
                                    <Autocomplete
                                        disableClearable
                                        multiple
                                        limitTags={1}
                                        size="small"
                                        options={getAllowedEnvironments()}
                                        value={filters?.Environment || []}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        onChange={(_, newValue) => {
                                            if (newValue.length > 0) {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    Environment: newValue.map(item => ({
                                                        label: item.label,
                                                        value: item.value
                                                    }))
                                                }));
                                            } else {
                                                handleRemoveFilter('Environment');
                                            }
                                        }}
                                        getOptionLabel={(option) => option.label || ''}
                                        sx={{
                                            width: '100%',
                                            '& .MuiOutlinedInput-root': {
                                                paddingRight: '0px !important',
                                                paddingTop: '4px !important',
                                                paddingBottom: '4px !important',
                                            }
                                        }}
                                        PaperComponent={({ children }) => (
                                            <Paper style={{ maxHeight: '250px' }}>{children}</Paper>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder={isEmpty(filters?.Environment) ? 'Select Environment' : ''}
                                                sx={{ minWidth: 180 }}
                                            />
                                        )}
                                    />
                                </Box>
                            </Stack>
                        }
                    />
                ) : (
                    <CasesSubHeader
                        search={search}
                        onSearch={handleSearch}
                        filters={filters}
                        onRemoveFilter={handleRemoveFilter}
                        hasAttachments={hasAttachments}
                        onSwitchChange={(checked) => setHasAttachments(checked)}
                        startDate={startDate}
                        onStartDateChange={handleStartDateChange}
                        endDate={endDate}
                        onEndDateChange={handleEndDateChange}
                        onClearFilters={handleClearFilters}
                        extraFilters={
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Typography
                                        sx={{
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            color: '#8492A6',
                                        }}>
                                        STATUS
                                    </Typography>
                                    <Autocomplete
                                        disableClearable
                                        multiple
                                        limitTags={1}
                                        size="small"
                                        options={getAllowedStatuses()}
                                        value={filters?.Status || []}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        onChange={(_, newValue) => {
                                            if (newValue.length > 0) {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    Status: newValue.map(item => ({
                                                        label: item.label,
                                                        value: item.value
                                                    }))
                                                }));
                                            } else {
                                                handleRemoveFilter('Status');
                                            }
                                        }}
                                        getOptionLabel={(option) => option.label || ''}
                                        sx={{
                                            width: '100%',
                                            minWidth: 220,
                                            '& .MuiOutlinedInput-root': {
                                                paddingRight: '0px !important',
                                                paddingTop: '4px !important',
                                                paddingBottom: '4px !important',
                                            }
                                        }}
                                        PaperComponent={({ children }) => (
                                            <Paper style={{ maxHeight: '250px' }}>{children}</Paper>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder={isEmpty(filters?.Status) ? "Select Status" : ""}
                                                sx={{ minWidth: 180 }}
                                            />
                                        )}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Typography
                                        sx={{
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            color: '#8492A6',
                                        }}>
                                        ENVIRONMENT
                                    </Typography>
                                    <Autocomplete
                                        disableClearable
                                        multiple
                                        limitTags={1}
                                        size="small"
                                        options={getAllowedEnvironments()}
                                        value={filters?.Environment || []}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        onChange={(_, newValue) => {
                                            if (newValue.length > 0) {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    Environment: newValue.map(item => ({
                                                        label: item.label,
                                                        value: item.value
                                                    }))
                                                }));
                                            } else {
                                                handleRemoveFilter('Environment');
                                            }
                                        }}
                                        getOptionLabel={(option) => option.label || ''}
                                        sx={{
                                            width: '100%',
                                            '& .MuiOutlinedInput-root': {
                                                paddingRight: '0px !important',
                                                paddingTop: '4px !important',
                                                paddingBottom: '4px !important',
                                            }
                                        }}
                                        PaperComponent={({ children }) => (
                                            <Paper style={{ maxHeight: '250px' }}>{children}</Paper>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder={isEmpty(filters?.Environment) ? 'Select Environment' : ''}
                                                sx={{ minWidth: 180 }}
                                            />
                                        )}
                                    />
                                </Box>
                            </Stack>
                        }
                    />
                )}
                <CustomizedTable
                    heading="Testing Cases"
                    loading={fetchingData}
                    columns={customColumns}
                    page={page}
                    limit={pageSize}
                    handleLimit={handlePageSize}
                    handlePage={handlePage}
                    data={allData}
                    totalRecords={totalCount}
                    showCheckBoxes
                    getFilterOptions={getFilterOptions}
                    handleSort={handleSort}
                    sort={sort}
                    handleApplyFilter={handleApplyFilter}
                    filters={filters}
                    navigateUrl="/cases"
                    navigateToKey
                    selectRowData
                    customizableColumns
                    defaultVisibleColumns={visibleColumns}
                    onColumnChange={(newColumns) => setVisibleColumns(newColumns)}
                    storageKey="cases"
                />
            </Container>
        </>
    );
}

export default TestingCases;
